import React, { Fragment, useState, useEffect, useCallback } from "react";

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import { DataGrid, GridRowModes, GridActionsCellItem, GridRowEditStopReasons, useGridApiRef } from '@mui/x-data-grid';
import { frFR as dataGridfrFR } from '@mui/x-data-grid/locales';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import { red, common, blue } from '@mui/material/colors';
// import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

import dayjs from 'dayjs';
import "dayjs/locale/fr";

import { useAuth } from '#utils/auth';
import { useFetch } from "#utils/fetch";

import { TitlePage } from "#components/TitlePage";
import { TextError, TextTip } from '#components/TextInformation';
import { useApiReservations } from "#services/apiReservations";
import { useApiResourceDefinition } from "#services/apiResourceDefinition";
import ScrollButtonToTop from '#components/ScrollButtonToTop'
import ConfirmDelete from '#components/ConfirmDelete';
import useFunctions from '#utils/functions';
//import { GiConsoleController } from "react-icons/gi";

export function Reservations() {

    const { user } = useAuth();
    const api = useApiReservations();
    const apiRed = useApiResourceDefinition();
    const [redList, setRedList] = useState({});

    // chargement définition resources pour edition
    useEffect(() => {       
        apiRed.getData('inuse')
            .then((json) => {
                if (json.returnCode === 0) {
                    if (json.returnDataCount>0) {
                        // on crée les tableaux pour le combo
                        let tempList = {};
                        tempList[0]=[];
                        json.returnData.map((r) => {
                            if (!tempList[r.red_far_id]) {
                                tempList[r.red_far_id]=[{
                                    value : 0,
                                    label : " "
                                }];
                            }                           
                            tempList[r.red_far_id].push({
                                value : r.red_id,
                                label : r.red_lib_far_lib //r.red_lib
                            });
                            // pour le filtre
                            tempList[0].push({
                                value : r.red_id,
                                label : r.red_lib_far_lib //r.red_lib
                            });

                        });
                        setRedList(tempList);
                    }
                } 
            });

    }, [user]);


    const { formatDate } = useFunctions();

    const [errorMessage, setErrorMessage] = useState("")

    const [activeTab, setActiveTab] = useState(0);
    const [isWorking, setIsWorking] = useState(false);

    // edit une reservation -----------------------------------------------------------
    const [rowModesModel, setRowModesModel] = React.useState({});
    const apiRef = useGridApiRef();

    const handleEditClick = (row, event) => {
        //console.log('handleEdit',row.urv_id);        
        setRowModesModel({ ...rowModesModel, [row.urv_id]: { mode: GridRowModes.Edit } });
        apiRef.current.startCellEditMode({id : row.urv_id, field : 'urv_red_id' });
    };

    const handleSaveClick = (row, event) => {
        //console.log('SaveClick', row.urv_id); 
        setRowModesModel({ ...rowModesModel, [row.urv_id]: { mode: GridRowModes.View } });
    };    

    const handleCancelClick = (row, event) => {
        //console.log('CancelClick', row.urv_id); 
        setRowModesModel({ ...rowModesModel, [row.urv_id]: { mode: GridRowModes.View } });
    };        

    const handleRowEditStop = (params, event) => {
        //console.log('RowEditStop', params);
        /*
        apiRef.current.stopCellEditMode({
            id: params.row.urv_id,
            field: 'urv_red_id',
            ignoreModifications: true, // will also discard the changes made
          });        
        */
        /*  
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
        */    
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        //console.log('RowModelChange'); 
        //setRowModesModel(newRowModesModel);
    };

    // row update
    const handleProcessRowUpdate = useCallback( 
        async  (updatedRow, originalRow) => {
//            console.log(updatedRow, originalRow);
            setIsWorking(true);
            const response = await api.updateData(updatedRow)
            setIsWorking(false);
            if (response.returnCode===0) {
                return updatedRow        
            } else {
                // TODO : Afficher message erreur
                return originalRow        
            }            
        }
        , []
    );

    const handleProcessRowUpdateError = (errors) => {
        console.log(errors);
    }

    // supprime une réservation -----------------------------------------------------------
    const [isOpenConfirmDeleteDialog, setIsOpenConfirmDeleteDialog] = useState(false);
    const [contentTextDeleteDialog, setContentTextDeleteDialog] = useState('');
    const [urvIdToDelete, setUrvIdToDelete] = useState(0);

    const handleRemoveClick = (row, event) => {
        event.stopPropagation();
        let txt = 'Voulez-vous vraiment supprimer la réservation de ' + row.urv_usr_firstname + ' ' + row.urv_usr_name;
        txt += ' pour un ' + row.urv_far_lib + ' ?';
        txt += "<br /><br />Date : " + formatDate(row.urv_date);
        txt += "<br />Horaire : " + row.urv_tis_lib;

        setUrvIdToDelete(row.urv_id);
        setContentTextDeleteDialog(txt);
        setIsOpenConfirmDeleteDialog(true);        
    };

    const handleNoDelete = () => {
        setUrvIdToDelete(0);
        setIsOpenConfirmDeleteDialog(false);
        setContentTextDeleteDialog('');
    }
    const handleYesDelete = () => {
        setIsWorking(true);
        let keyTab = refCodeTabs[activeTab].code;

        api.deleteData(urvIdToDelete)
            .then((json) => {
                setIsWorking(false);
                if (json.returnCode === 0) {
                    setUrvIdToDelete(0);
                    setIsOpenConfirmDeleteDialog(false);
                    setContentTextDeleteDialog('');
                    if (json.returnDataCount === 1) {
                        // refresh
                        let tempL = { ...isTabLoaded };
                        tempL[keyTab] = false;
                        setIsTabLoaded(tempL);
                    }
                    setErrorMessage(null);
                    updateDataInTab();
                } else {
                    setUrvIdToDelete(0);
                    setIsOpenConfirmDeleteDialog(false);
                    setContentTextDeleteDialog('');
                    setErrorMessage(json.returnMsg || 'Erreur suppression');
                }
            });
    }
    //--------------------------------------------------------------
    // définition des listes 

    dayjs().locale('fr');

    const refCodeTabs = [
        { code: 'today', lib: "Aujourd'hui", comment: "Réservation du " + formatDate(dayjs()) }
        , { code: 'thisweek', lib: "Cette semaine", comment: "Semaine du " + formatDate(dayjs().startOf('week')) + " au " + formatDate(dayjs().endOf('week')) }
        , { code: 'nextweek', lib: "Semaine prochaine", comment: "Semaine du " + formatDate(dayjs().startOf('week').add(7, 'day')) + " au " + formatDate(dayjs().endOf('week').add(7, 'day')) }
        , { code: 'future', lib: "A venir", comment: "A partir de demain" }
        , { code: 'history', lib: "Historique" }
    ]

    const baseColumns = [
        { field: 'urv_id', headerName: 'ID', width: 90, type: 'number' },
        {
            field: 'urv_date', headerName: 'Date', width: 100, type: 'date'
            , valueFormatter: (value) => {
                return formatDate(value ||'');
            }
        },
        { field: 'urv_tis_lib', headerName: 'Horaire', type: 'string', width: 120 },
        { field: 'urv_far_lib', headerName: 'Type bureau Abo.', type: 'string', width: 150 },
        //{ field: 'urv_red_lib', headerName: 'Bureau ',  type: 'string', width: 150 },        
        { field: 'urv_red_id', headerName: 'Bureau réservé',  width: 300, editable : true ,
            type: 'singleSelect',
            valueOptions : ({row})=> {
                return redList[0] || [{
                    value : 0,
                    label : ' '
                }]; 
/* pas de filtre selon le type d'abo pour cette vue admin pour l'instant
                if (!row) {
                    return redList[0];  // pour le filtre
                } else if (redList[row.urv_far_id]) {
                    return redList[row.urv_far_id]
                } else {    
                    return [{
                        value : 0,
                        label : ' '
                    }];                    
                }
*/                    
            }    
        },
        { field: 'urv_usr_libr', headerName: 'Compte', width: 250 },
        //{ field: 'urv_usr_firstname', headerName: 'Prénom', width: 150},
        //{ field: 'urv_usr_name', headerName: 'Nom', width: 150},
        //{ field: 'urv_usr_email', headerName: 'Email / Login', width: 250 },
        {
            field: 'actions',             
            type : 'actions', //disableColumnMenu: true, resizable: false, filterable: false, sortable: false, editable: false, groupable: false, 
            headerName: 'Actions',
            width: 90, headerAlign: 'center', align: 'center',
            
            renderCell: (params) => {
                const isInEditMode = rowModesModel[params.row.urv_id]?.mode === GridRowModes.Edit;
                if (isInEditMode) {
                    return (
                        <Box>
                            <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleSaveClick(params.row, e)} >
                                <SaveIcon sx={{ color: common[900]}}/> 
                            </IconButton>

                            <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleCancelClick(params.row, e)} >
                                <CancelIcon sx={{ color: red[500] }} />
                            </IconButton>
                        </Box>
                    )
                }
                return (
                    <Box>
                        <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleEditClick(params.row, e)} >
                            <EditIcon sx={{ color: common[900]}}/> 
                        </IconButton>

                        <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleRemoveClick(params.row,e)} >
                            <DeleteIcon sx={{ color: red[500] }} />
                        </IconButton>
                    </Box>
                );
            }
                
        }
    ].map(
        // valeur commune      
        (col) => {
            col.headerClassName = 'app-theme--header';
            col.editable = col.editable || false;  
            col.sortable = col.sortable || false;  // pb disableColumnSorting, on doit l'indiquer pour chaque column !      
            return col;
        }
    );

    // fonction pour init selon les tabs !
    const initFromTabs = (initValue) => {
        let arrayTabs = refCodeTabs.map((x) => x.code);
        let r = {};
        arrayTabs.forEach((tab) => { r[tab] = initValue; });
        return r;
    };

    const columns = initFromTabs(baseColumns);

    //--------------------------------------------------------------            
    const [isTabLoaded, setIsTabLoaded] = useState(initFromTabs(false));
    const [data, setData] = useState(initFromTabs({}));

    //--------------------------------------------------------------        
    const [paginationModel, setPaginationModel] = useState(initFromTabs({
        page: 0,
        pageSize: 25
    }));
    const [filterModel, setFilterModel] = useState(initFromTabs({
        items: []
    }));
    const [sortModel, setSortModel] = useState(initFromTabs(
        []
    ));

    const [rowCount, setRowCount] = useState(initFromTabs(0));

    const onPaginationModelChange = (newPaginationModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...paginationModel };
        temp[keyTab] = newPaginationModel;
        setPaginationModel(temp);
    };

    const onFilterModelChange = (newFilterModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...filterModel };
        temp[keyTab] = newFilterModel;
        setFilterModel(temp);
    };

    const onSortModelChange = (newSortModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...sortModel };
        temp[keyTab] = newSortModel;
        setSortModel(temp);
    };

    //--------------------------------------------------------------    
    const handleChangeTab = (event, newValue, other) => {
        setActiveTab(newValue);
    };

    const getRowId = (data) => {
        return (data && data.urv_id) ||0;
    }

    useEffect(() => {
        updateDataInTab();        
    }, [user, activeTab, paginationModel, filterModel]);

    const updateDataInTab = () => {
        let keyTab = refCodeTabs[activeTab].code;

        if (user) { 
            setIsWorking(true);
            api.getData(keyTab, paginationModel[keyTab], filterModel[keyTab], sortModel[keyTab])
                .then((json) => {
                    setIsWorking(false);
                    let tempL = { ...isTabLoaded };
                    let tempD = { ...data };
                    let tempRC = { ...rowCount }
                    tempL[keyTab] = true;
                    if (json.returnCode === 0) {
                        tempD[keyTab] = json.returnData;
                        tempRC[keyTab] = json.returnTotalDataCount;
                        setErrorMessage('');
                    } else {
                        tempD[keyTab] = {};
                        tempRC[keyTab] = 0;
                        setErrorMessage(json.returnMsg || 'Erreur récupération des réservations');
                    }
                    setData(tempD);
                    setRowCount(tempRC);
                    setIsTabLoaded(tempL);
                });
        }
    }

    //--------------------------------------------------------------        
    const getData = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return (data[key] && data[key].length > 0) ? data[key] : null;
    }
    const getCol = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return (columns[key] && columns[key].length > 0) ? columns[key] : null;
    }
    const getCommentActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].comment;
        return key ? key : '';
    }
    const getRowCountActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return rowCount[key];
    }
    const getPaginationModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return paginationModel[key];
    }
    const getFilterModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return filterModel[key];
    }
    const getSortModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return sortModel[key];
    }

    const CustomNoRowsOverlay = () => {
        return <Box sx={{ pt: 5, width : '100%', textAlign : 'center' }}>Aucune réservation</Box>
    }

    return (
        <Fragment>
            {/* pour la gestion de la suppression */}
            <ConfirmDelete open={isOpenConfirmDeleteDialog} contentText={contentTextDeleteDialog} handleNo={handleNoDelete} handleYes={handleYesDelete} />

            <TitlePage titlePage="Réservations"
                showAddButton="right" tooltipAddButton="Ajouter une réservation" routeAddButton="/Admin/Reservation/Add"
            />

            {errorMessage !== '' && <TextError>{errorMessage}</TextError>}

            <Container sx={{ pt: 2, pb: 4 }} maxWidth="xl" >

                {/* les tabs  */}
                <Box sx={{ mb: 2, py: 0, px: 0, borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={activeTab} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                        {
                            refCodeTabs.map((value, index) => (
                                <Tab key={index} label={value.lib} wrapped={true} />
                            ))
                        }
                    </Tabs>
                </Box>
                <TextTip>{getCommentActiveTab(activeTab)}</TextTip>

                {/* les datas */}
                <DataGrid 
                    localeText={dataGridfrFR.components.MuiDataGrid.defaultProps.localeText}                    
                    sx={
                        getRowCountActiveTab(activeTab)>0 ? {minHeight:200}: {height:200} //  important pour afficher l'overlay                        
                    } 
                    slots={{ 
                        noRowsOverlay: CustomNoRowsOverlay,
                    }}
                    density='compact'
                    disableColumnSelector={true}

                    rowModesModel={rowModesModel}
                    onRowModesModelChange={handleRowModesModelChange}
                    onRowEditStop={handleRowEditStop}

                    apiRef={apiRef}
                    editMode='row'  
                    processRowUpdate={handleProcessRowUpdate} 
                    onProcessRowUpdateError={handleProcessRowUpdateError}

                    loading={isWorking}
                    getRowId={getRowId}
                    rows={getData(activeTab) || []}
                    rowCount={getRowCountActiveTab(activeTab)}
                    columns={getCol(activeTab)}

                    filterMode="server"
                    onFilterModelChange={onFilterModelChange}
                    filterModel = {getFilterModelActiveTab(activeTab)}                    

                    sortingMode="server"
                    onSortModelChange={onSortModelChange}
                    sortModel = {getSortModelActiveTab(activeTab)}

                    paginationMode="server"
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationModel={getPaginationModelActiveTab(activeTab)}
                    onPaginationModelChange={onPaginationModelChange}

                />
            </Container>

            <ScrollButtonToTop />

        </Fragment>
    );
};
